import { Configuration, PopupRequest } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "your-client-id", // Replace with your app registration's client ID
        authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/your-tenant-id", // Replace with your tenant ID
        redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "GroupMember.Read.All", "Calendars.ReadWrite"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphGroupsEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf",
};

// Calendar Editors group ID - replace with your actual Azure AD group ID
export const CALENDAR_EDITORS_GROUP_ID = process.env.REACT_APP_CALENDAR_EDITORS_GROUP_ID || "your-group-id";

// Azure Blob Storage configuration
export const azureBlobConfig = {
    accountName: process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME || "your-storage-account",
    containerName: process.env.REACT_APP_AZURE_STORAGE_CONTAINER_NAME || "calendar-data",
    sasToken: process.env.REACT_APP_AZURE_STORAGE_SAS_TOKEN || "",
    blobName: "calendar-events.json",
};